import { StylesProvider } from '@material-ui/styles';
import React from 'react';
import { createStore } from 'redux';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import rootReducer from './reducers';
import * as serviceWorker from './serviceWorker';
import App from './components/App';
import './index.scss';

const store = createStore(rootReducer);
self.pendingRequests = 0; // eslint-disable-line no-restricted-globals

ReactDOM.render(
  <Provider store={store}>
    <StylesProvider injectFirst>
      <App />
    </StylesProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
